<template>
  <div class="col-md-12">
    <b-card
      header-bg-variant="primary"
      header-text-variant="white"
      bg-variant="default"
      align="center"
      style="filter: drop-shadow(0px 2px 14px rgba(0, 0, 0, 0.15)); border-radius: 10px;"
    >
      <div class="row d-flex justify-content-end" style="margin-bottom: 20px">
        <button
          type="button"
          class="hidden-button"
          @click="refreshData"
          id="refreshButton"
          >
          <i class="fas fa-sync-alt"></i>
        </button>
        <button
          class="btn btn-tambah-data"
          @click.prevent.stop="showModalAdd = true"
        >
          <i class="fa fa-plus-circle" style="color: #ffffff;"></i>Tambah Data
        </button>
      </div>
      <DxDataGrid
        :ref="dataGridRefKey"
        :data-source="dataSource"
        key-expr="id"
        :columns="columns"
        :show-borders="true"
        :word-wrap-enabled="true"
        :column-auto-width="true"
        :remote-operations="true"
        :column-hiding-enabled="true"
      >
        <DxScrolling
          :use-native="true"
          :scroll-by-content="true"
          :scroll-by-thumb="true"
          show-scrollbar="onHover"
        />
        <!--          <DxColumn :width="100" data-field="id" caption="No." />-->
        <DxFilterRow :visible="true" />
        <DxColumn
          data-field="name"
          caption="Nama Kabupaten/Kota"
          sort-order="asc"
          :filter-operations="['contains']"
        />
        <DxColumn
          data-field="code"
          caption="Kode Kabupaten/Kota"
          :allow-filtering="false"
        />
        <DxColumn
          data-field="provinsi.name"
          caption="Provinsi"
          :filter-operations="['contains']"
          :allow-filtering="false"
        />
        <DxColumn :width="100" type="buttons" caption="Aksi">
          <DxButton icon="fa fa-trash" hint="Hapus" :onClick="iconDelete" />
          <DxButton icon="fa fa-edit" hint="Edit" :onClick="iconEdit" />
        </DxColumn>
        <DxPaging :page-size="10" />
        <DxPager
          :visible="true"
          :show-page-size-selector="showPageSizeSelector"
          :allowed-page-sizes="pageSizes"
        />
      </DxDataGrid>
    </b-card>
    <!--   Modal Tambah Kabupaten/Kota   -->

    <b-modal v-model="showModalAdd" hide-footer centered id="modal-tambah">
      <template #modal-header="{ close }">
        <h5 class="title-card-custom">Tambah Kabupaten/Kota</h5>
      </template>
      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group id="example-input-group-1" label-for="example-input-1">
          <template v-slot:label>
            Nama Kabupaten/Kota <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="example-input-1"
            name="example-input-1"
            placeholder="Nama"
            v-model="$v.form.name.$model"
            :state="validateState('name')"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback"
            >Nama Kabupaten/Kota harus diisi.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="example-input-group-2" label-for="example-input-2">
          <template v-slot:label>
            Kode Kabupaten/Kota<span class="text-danger">*</span>
          </template>
          <b-form-input
            id="example-input-2"
            name="example-input-2"
            placeholder="Kode"
            v-model="$v.form.code.$model"
            :state="validateState('code')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback"
            >Kode Kabupaten/Kota harus diisi.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="example-input-group-3" label-for="select-provinsi">
          <template v-slot:label>
            Provinsi <span class="text-danger">*</span>
          </template>
          <b-form-select
            id="select-provinsi"
            v-model="form.provinsi"
            :options="provinsis"
            :state="validateState('provinsi')"
            aria-describedby="input-3-live-feedback"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >-- Pilih Salah Satu --</b-form-select-option
              >
            </template>
          </b-form-select>

          <b-form-invalid-feedback id="input-3-live-feedback"
            >Provinsi harus dipilih.
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <div class="d-flex justify-content-center">
          <button class="btn btn-delete mr-8" @click="resetForm()">
            Kembali
          </button>
          <button type="submit" class="btn btn-save">Simpan</button>
        </div>
      </b-form>
    </b-modal>

    <!--   Modal Edit Kabupaten/Kota  -->

    <b-modal v-model="showModalEdit" hide-footer centered id="modal-edit">
      <template #modal-header="{ close }">
        <h5 class="title-card-custom">Edit Kabupaten/Kota</h5>
      </template>
      <b-form @submit.stop.prevent="onSubmitEdit">
        <b-form-group id="edit-input-group-1" label-for="edit-input-1">
          <template v-slot:label>
            Nama Kabupaten/Kota<span class="text-danger">*</span>
          </template>
          <b-form-input
            id="edit-input-1"
            name="edit-input-1"
            placeholder="Nama"
            v-model="$v.formEdit.name.$model"
            :state="validateStateFormEdit('name')"
            aria-describedby="input-edit-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-edit-live-feedback"
            >Nama Kabupaten/Kota harus diisi.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="icon-input-group"
          label-for="code-input"
          label="Kode Kabupaten/Kota"
        >
          <b-form-input
            id="code-input"
            name="code-input"
            v-model="formEdit.code"
            disabled
          ></b-form-input>
        </b-form-group>

        <b-form-group id="example-input-group-3" label-for="select-provinsi">
          <template v-slot:label>
            Provinsi <span class="text-danger">*</span>
          </template>
          <b-form-select
            id="select-provinsi"
            v-model="formEdit.provinsi_id"
            :options="provinsis"
            :state="validateState('provinsi')"
            aria-describedby="input-3-live-feedback"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >-- Pilih Salah Satu --</b-form-select-option
              >
            </template>
          </b-form-select>

          <b-form-invalid-feedback id="input-3-live-feedback"
            >Provinsi harus dipilih.
          </b-form-invalid-feedback>
        </b-form-group>
        <hr />
        <div class="d-flex justify-content-center">
          <button class="btn btn-delete mr-7" @click="resetFormEdit()">
            Batal
          </button>
          <button
            type="submit"
            class="btn btn-save"
            :disabled="$v.formEdit.$invalid"
          >
            Simpan
          </button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  DxButton,
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxScrolling
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { handleErrors, isNotEmpty } from "@/core/appUtil/util";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import "whatwg-fetch";
import Swal from "sweetalert2";

let token = "";

const store = new CustomStore({
  key: "id",
  load: function(loadOptions) {
    let params = "?";
    [
      "skip",
      "take",
      "requireTotalCount",
      "requireGroupCount",
      "sort",
      // "filter",
      "totalSummary",
      "group",
      "groupSummary"
    ].forEach(function(i) {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    // search by name if exists

    if (
      Array.isArray(loadOptions["filter"]) &&
      loadOptions["filter"].length > 0 &&
      loadOptions["filter"][0] === "name"
    ) {
      params += "&nama=" + loadOptions["filter"][2];
    }
    return fetch(process.env.VUE_APP_URL_LOCAL + `/ref/kabkota${params}`)
      .then(response => response.json())
      .then(data => {
        if (data.data === null) {
          setTimeout(() => {
            document.querySelector("#refreshButton").click();
          }, 500);

        } else {
          return {
            data: data.data,
            totalCount: data.totalCount,
            summary: data.summary,
            groupCount: data.groupCount
          };
        }
      })
      .catch(() => {
        throw "Data Loading Error";
      });
  }
});

const dataGridRefKey = "my-data-grid";

const swalDelete = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-delete",
    cancelButton: "btn btn-cancel"
  },
  buttonsStyling: false
});

const swalSuccess = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-save",
    cancelButton: "btn btn-delete"
  },
  buttonsStyling: false
});

export default {
  mixins: [validationMixin],
  name: "KabupatenKota",
  components: {
    DxDataGrid,
    DxPaging,
    DxPager,
    DxColumn,
    DxButton,
    DxFilterRow,
    DxScrolling
  },
  data() {
    return {
      showModalAdd: false,
      showModalEdit: false,
      isValid: false,
      form: {
        name: null,
        code: null,
        provinsi: null
      },
      formEdit: {
        name: null,
        code: null,
        provinsi: null,
        provinsi_id: null
      },
      provinsis: [],
      dataSource: store,
      dataGridRefKey,
      showPageSizeSelector: true,
      pageSizes: [5, 10, 20],
      columns: ["id", "name", "code", "provinsi.name"],
      dataModal: {}
    };
  },
  mounted() {
    this.$store.dispatch("token/getAccessToken").then(access_token => {
      token = access_token;
    });

    fetch(encodeURI(process.env.VUE_APP_URL_LOCAL + `/ref/provinsi?take=100`), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + token
      }
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(items => {
        const detailMenu = items.data;
        let selectedOptions;
        selectedOptions = [];
        detailMenu.map(i => {
          return selectedOptions.push({
            text: i.name,
            value: i.id
          });
        });
        this.provinsis = selectedOptions;
      });
  },
  validations: {
    form: {
      name: {
        required
      },
      code: {
        required
      },
      provinsi: {
        required
      }
    },
    formEdit: {
      name: {
        required
      },
      provinsi_id: {
        required
      }
    }
  },
  computed: {
    dataGrid: function() {
      return this.$refs[dataGridRefKey].instance;
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateFormEdit(name) {
      const { $dirty, $error } = this.$v.formEdit[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        name: null,
        code: null
      };

      this.$nextTick(() => {
        this.$bvModal.hide("modal-tambah");
      });
    },
    resetFormEdit() {
      this.formEdit = {
        name: null,
        code: null
      };

      this.$nextTick(() => {
        this.$bvModal.hide("modal-edit");
      });
    },
    onSubmitEdit() {
      this.$v.formEdit.$touch();
      if (this.$v.formEdit.$anyError) {
        return;
      }

      let id = this.formEdit.id;

      let data = {
        name: this.formEdit.name,
        code: this.formEdit.code,
        provinsi_id: this.formEdit.provinsi_id
      };
      console.log(data);
      swalSuccess.fire({
        title: "Kirim Berkas",
        text: "Pastikan kembali data sudah sesuai.",
        icon: "warning",
        iconHtml: "?",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#18328D",
        confirmButtonText: "Simpan",
        cancelButtonText: "Batal",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return fetch(
            encodeURI(process.env.VUE_APP_URL_LOCAL + `/ref/kabkota/${id}`),
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: "bearer " + token
              },
              body: JSON.stringify(data)
            }
          )
            .then(handleErrors)
            .then(response => response.json())
            .then(data => {
              Swal.fire({
                position: "center",
                icon: data.status,
                title: "Data berhasil diubah",
                showConfirmButton: false,
                timer: 1500
              });
              this.resetFormEdit();
              this.refreshData();
            })
            .catch(error => {
              console.log(error);
              Swal.fire({
                title: "Kesalahan",
                text: "Gagal mengubah data",
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Kembali",
                confirmButtonColor: "#18328D"
              });
            });
        },
        allowOutsideClick: () => !Swal.isLoading()
      });
    },
    setDataModal(data) {
      this.dataModal(data);
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let id = this.form.code;

      let data = {
        id: parseInt(id),
        code: this.form.code,
        name: this.form.name,
        provinsi_id: this.form.provinsi
      };

      swalSuccess.fire({
        title: "Kirim Berkas",
        text: "Pastikan kembali data sudah sesuai.",
        icon: "warning",
        iconHtml: "?",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#18328D",
        confirmButtonText: "Simpan",
        cancelButtonText: "Batal",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return fetch(
            encodeURI(process.env.VUE_APP_URL_LOCAL + `/ref/kabkota`),
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "bearer " + token
              },
              body: JSON.stringify(data)
            }
          )
            .then(handleErrors)
            .then(response => response.json())
            .then(data => {
              Swal.fire({
                position: "center",
                icon: data.status,
                title: "Data berhasil ditambah",
                showConfirmButton: false,
                timer: 1500
              });
              this.resetForm();
              this.refreshData();
            })
            .catch(error => {
              console.log(error);
              Swal.fire({
                title: "Kesalahan",
                text: "Data yang ditambah sudah ada",
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Kembali",
                confirmButtonColor: "#18328D"
              });
            });
        },
        allowOutsideClick: () => !Swal.isLoading()
      });
    },
    refreshData() {
      this.dataGrid.refresh();
    },
    iconDelete(e) {
      let id = e.row.data.id;
      swalDelete.fire({
        text: "Yakin ingin hapus data?",
        icon: "warning",
        iconHtml: "?",
        showCancelButton: true,
        confirmButtonText: "Hapus",
        cancelButtonText: "Batal",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return fetch(
            encodeURI(process.env.VUE_APP_URL_LOCAL + `/ref/kabkota/${id}`),
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: "bearer " + token
              }
            }
          )
            .then(handleErrors)
            .then(response => response.json())
            .then(data => {
              console.log(data);
            })
            .catch(error => {
              console.log(error);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Data berhasil dihapus",
                showConfirmButton: false,
                timer: 1500
              });
              this.refreshData();
            });
        },
        allowOutsideClick: () => !Swal.isLoading()
      });
    },
    iconEdit(e) {
      const data = e.row.data;
      this.formEdit.name = data.name;
      this.formEdit.code = data.code;
      this.formEdit.id = data.id;
      this.formEdit.provinsi_id = data.provinsi_id;
      this.setDataModal = data;
      this.$root.$emit("bv::show::modal", "modal-edit", e.row.data);
    }
  }
};
</script>
